import { all } from 'redux-saga/effects';
import weatherSaga from './components/common/redux/sagas/weatherSaga';

export function* sagas() {
  yield all([
    weatherSaga(),
  ]);
}

export default sagas;
